export default "__VITE_ASSET__DCRn0Fea__"